<template>
  <div :class="['axiome-logique-container', 'axiome-logique-max-cardinality']">
    <!--Affichage OnProperty-->
    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="onPropertyLiterals" :leftMargin="false" :showLanguageBadge="showLanguageBadge" />
      <AttributeBlankNode :blankNodes="onPropertyBlanknodes" :leftMargin="false" :braceDisplay="true"
        :showLanguageBadge="showLanguageBadge"
        :showFirstOperand="onPropertyLiterals !== undefined && onPropertyLiterals.length > 0" />
    </div>


    <!--Affichage Operand-->
    <span :class="['axiome-logique-operand', ' ml-2', ' mr-2', { 'axiome-logique-operand-level0': level0 }]">max</span>


    <div :class="['display-flew-column', { 'display-flew-column-level0': level0 }]">
      <PropertyValue :values="maxCardinalityLiterals" :leftMargin="false" :showLanguageBadge="showLanguageBadge" />
    </div>
  </div>
</template>

<script>
export default {
  name: "LogicalAxiomeMaxCardinality",
  computed: {
    maxCardinalityLiterals() {
      let result = [];
      this.maxCardinality.forEach(element => {
        result.push(...element.literals);
      });
      return result;
    }

  },
  props: {
    level0: {
      type: Boolean,
      default: false
    },
    maxCardinality: {
      type: Array,
      default: () => []
    },
    onPropertyBlanknodes: {
      type: Array,
      default: () => []
    },
    onPropertyLiterals: {
      type: Array,
      default: () => []
    },
    showLanguageBadge: {
      type: Boolean,
      default: false
    }
  }
}
</script>
